// Tokenizer adresów URL — czysta logika bez DOM, żeby dało się testować w `deno test`.
// Spec: spec/lista-zadan.md, "Hiperłącza w tytule i opisie". Warstwa DOM: linkify.ts.

export interface LinkSpan {
  start: number;
  end: number;
  href: string;
  label: string;
}

const URL_RE = /(?:https?:\/\/|www\.)[^\s<>"'`]+/gi;
const TRAILING_PUNCT = '.,;:!?…';

function count(s: string, ch: string): number {
  let n = 0;
  for (const c of s) if (c === ch) n++;
  return n;
}

/** Znajduje adresy URL w tekście. Końcowa interpunkcja i niesparowany nawias zamykający nie należą do linku. */
export function findLinks(text: string): LinkSpan[] {
  const out: LinkSpan[] = [];
  for (const m of text.matchAll(URL_RE)) {
    let label = m[0];
    while (label.length > 0) {
      const last = label[label.length - 1];
      if (TRAILING_PUNCT.includes(last)) { label = label.slice(0, -1); continue; }
      if (last === ')' && count(label, ')') > count(label, '(')) { label = label.slice(0, -1); continue; }
      if (last === ']' && count(label, ']') > count(label, '[')) { label = label.slice(0, -1); continue; }
      break;
    }
    // Samo "www." albo "https://" bez hosta to nie link.
    if (!/^(?:https?:\/\/|www\.)[^./]/i.test(label)) continue;
    const href = /^https?:\/\//i.test(label) ? label : 'https://' + label;
    const start = m.index ?? 0;
    out.push({ start, end: start + label.length, href, label });
  }
  return out;
}
